import { PurchaseLoadRecord } from '../../../types/purchaseLoad';
import { TicketSidebarCard } from '../shared/TicketSidebarCard';

import { TicketPurchaseLoadStatusBadge } from './TicketPurchaseLoadStatusBadge';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type InboundTicketListCardProps = {
  ticket: PurchaseLoadRecord;
  onSelect: () => void;
};

//
// ⚛️ ⚛️ ⚛️ INBOUND TICKET LIST CARD ⚛️ ⚛️ ⚛️
//
export const InboundTicketListCard = ({
  ticket,
  onSelect,
}: InboundTicketListCardProps) => {
  const t = useTranslations();

  const imageFiles = (ticket.files ?? []).filter((f) =>
    f.mimeType.startsWith('image/'),
  );

  return (
    <TicketSidebarCard
      id={ticket.id}
      documentNumber={ticket.documentNumber}
      contactType={t.scaleTicketPro.supplier}
      contactName={ticket.supplierAccount?.name ?? null}
      subtitle={
        ticket.purchaseOrder?.documentNumber
          ? `PO #${ticket.purchaseOrder.documentNumber}`
          : (ticket.facility?.facilityName ?? null)
      }
      notesPreview={ticket.internalNotes ?? null}
      lineItemCount={ticket.lineItemCount ?? 0}
      date={ticket.receivedDate}
      isSelected={false}
      onSelect={onSelect}
      imageFiles={imageFiles}
      statusBadge={<TicketPurchaseLoadStatusBadge status={ticket.status} />}
      className="@InboundTicketListCard"
    />
  );
};
